export interface IEdoCourseYear {
  id?: number;
  year?: number;
}

export const defaultValue: Readonly<IEdoCourseYear> = {};
